import { useEffect } from "react";

const BASE = "Dorothée Lancelot";
const SHARE_IMG = "https://static.prod-images.emergentagent.com/jobs/a75f6c93-eb9c-4345-be07-d254357403cc/images/8cb73758e664d40c0e0e4ebaa246f2a5b60fd7a78a4a073df0e6078b98a66ac6.jpeg";
const SITE = "https://dorotheelancelot.fr";

export function useSeo({ title, description, jsonLd, path, image, keywords }) {
  useEffect(() => {
    const fullTitle = title ? `${title} — ${BASE}` : `${BASE} — Auteure • Médium • Conférencière • Onirothérapeute`;
    document.title = fullTitle;
    const url = SITE + (path || window.location.pathname);

    const setMeta = (attr, key, content) => {
      if (!content) return;
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("name", "description", description);
    setMeta("name", "keywords", Array.isArray(keywords) ? keywords.join(", ") : keywords);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", BASE);
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", image || SHARE_IMG);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", image || SHARE_IMG);

    // canonical
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);

    // JSON-LD
    let script = document.getElementById("dl-jsonld");
    if (jsonLd) {
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = "dl-jsonld";
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) {
      script.remove();
    }

    window.scrollTo(0, 0);
  }, [title, description, jsonLd, path, image, keywords]);
}
